import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';
import CredentialDateInfo from '../credential-date-info';
interface Props {
    taskDescription: string;
    deviceType: string;
    cardCode: string;
    enrolmentType: string;
    device: string;
    onBack: (event: any) => void;
}

const SummaryForm: FC<Props> = ({ taskDescription, deviceType, cardCode, enrolmentType, onBack, device }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <WizardSummaryLayout onBack={(event) => onBack(event)} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskDescription}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.deviceType)}: <span className="text-sm text-black">{deviceType}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.device)}: <span className="text-sm text-black">{device}</span></h4>
            </div>
        </div> <div className="flex flex-row pt-3">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.enrol)}: <span className="text-sm text-black">{enrolmentType}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.card)}: <span className="text-sm text-black">{cardCode}</span></h4>
                <CredentialDateInfo values={values} />
            </div>
        </div>
    </WizardSummaryLayout>
}

export default SummaryForm;
